import { createReducer, on } from '@ngrx/store';

import * as fromInvoicesModuleModels from '../../../invoices/models';
import { CustomerInvoicesActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromInvoicesModuleModels.CorrectionInvoice };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(CustomerInvoicesActions.ReadCustomerInvoices, state => {
    return {
      ...state,
      loading: true
    };
  }),
  on(
    CustomerInvoicesActions.ReadCustomerInvoicesSuccess,
    (state, { response }) => {
      const items = response['hydra:member'];
      const entities = items.reduce(
        (
          entities: {
            [iri: string]: fromInvoicesModuleModels.CorrectionInvoice;
          },
          item
        ) => {
          return {
            ...entities,
            [item['@id']]: item
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        errors: {},
        loaded: true,
        loading: false
      };
    }
  ),
  on(
    CustomerInvoicesActions.ReadCustomerInvoicesFail,
    (state, { type, response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false
      };
    }
  ),
  on(CustomerInvoicesActions.ResetCustomerInvoicesState, state => {
    return {
      ...initialState
    };
  }),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
